import axios from '@/utils/api'

const actions = {

  async findTiposDocumento ({ commit }, url) {
    const result = await axios({
      url: `publico/tipoDocumento/${url}`,
      method: 'GET'
    })

    return result
  },

  async findTiposDocumentoTipoProcesso ({ commit }, { url, tipo }) {
    const result = await axios({
      url: `publico/tipoDocumento/${url}/${tipo}`,
      method: 'GET'
    })

    return result
  },

  async findTiposDocumentoInvalidos ({ commit }, { protocolo }) {
    const result = await axios({
      url: `publico/tipoDocumento/getTiposDocumentosInvalidos/${protocolo}`,
      method: 'GET'
    })

    return result
  },

  async findTiposDocumentoByCodigo ({ commit }, { codigo }) {
    const result = await axios({
      url: `publico/tipoDocumento/getTiposDocumentosRetificacao/${codigo}`,
      method: 'GET'
    })

    return result
  },

  async findTiposDocumentoPosseMansaEPacifica ({ commit }, { protocolo }) {
    const result = await axios({
      url: `publico/tipoDocumento/getTiposDocumentosPosseMansaEPacifica`,
      method: 'GET'
    })

    return result
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/tipoDocumento.js